module.exports = "<li [ngClass]=\"{disabled: isDisabled()}\">\n    <div class=\"nav-item sidebar-item\" [ngClass]=\"{active: isActive(node.url)}\">\n        <a class=\"nav-link text-title\" [ngClass]=\"nodeClass\" [routerLink]=\"node.url\">\n            <i *ngIf='node.iconClass' class=\"fa fa-fw\" [ngClass]=\"node.iconClass\"></i>\n            <span>{{node.label}}</span>\n        </a>\n    </div>\n\n    <ul *ngFor=\"let child of node.children\">\n        <app-nav-node [node]=\"child\"></app-nav-node>\n    </ul>\n</li>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_shared/nav/nav-node.component.html
// module id = 765
// module chunks = 0